import { combineEpics } from 'redux-observable';
import { dataSourceValidateTriggerEpicReducer } from '../ducks/DataSourceValidate.ducks';
export default combineEpics(dataSourceValidateTriggerEpicReducer.epic);

//# sourceMappingURL=DataSourceValidateTriggerEpic.js.map
